class HCartHandler extends HElement {
  items = []
  total = '0'
  total_number = 0
  coinFormatter = new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' })
  constructor() {
    super()
    this.$totalItems = document.querySelector('#cartDrawerCounter')
    this.$totalPricing = document.querySelector('#CartDrawerTotal')
    this.$cartDrawer = document.querySelector("cart-drawer")
    this.processCart(window.CartSubscriber.cart)
    this.makeState('items', this.items)
    this.makeState('total', this.total)
    this.makeState('total_number', this.total_number)
    this.makeState('updater', null)
    CartSubscriber.on('updated', ({ cart }) => {
      this.processCart(cart)
      this.updater = null
    })
  }
  mount() {
    super.mount()
  }
  processItems(items) {
    return items.filter(item => {
      console.log(item.properties)
      return !item.properties?.__ignore
    }).map(item => {
      return {
        id: 'i-' + item.id,
        variant_id: item.id,
        title: item.title,
        quantity: Number(item.quantity),
        image: item.image,
        final_price: this.coinFormat(item.line_price),
        price: this.coinFormat(item.final_price),
      }
    })
  }
  processCart(cart) {
    this.total_number = Number(cart.total_price / 100)
    this.total = this.coinFormat(Number(cart.total_price))
    this.items = this.processItems(cart.items)
    this.count = cart.item_count
    this.$totalItems.textContent = this.count
    this.$totalPricing.textContent = this.total
    this.$cartDrawer.classList.toggle('is-empty', cart.item_count === 0)
  }
  coinFormat(amount) {
    return this.coinFormatter.format(amount / 100)
  }

  // API
  async fetch(url, body) {
    return await fetch(url, {
      method: 'post',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(body)
    }).then(r => r.json())
  }
  async updateItem(update) {
    await this.fetch(`/cart/update.js`, {
      updates: {
        [update.id]: update.quantity
      }
    })
    this.updater = update.id
    CartSubscriber.update()
  }
  async addItem(item) {
    await this.fetch(`/cart/add.js`,{
      items: [item]
    })
    CartSubscriber.update()
  }
}
customElements.define('h-cart-handler', HCartHandler)

class HCartItem extends HReactiveElement {
  quantity = 5
  constructor() {
    super()
    this.cart = document.querySelector("#cartData")
  }
  template(item) {
    const { title, price, quantity, image, variant_id } = item
    return `
      <style>
        .container {
          padding: var(--y-padding) var(--x-padding);
          display: grid;
          grid-template-columns: 40% 1fr;
          align-items: center;
          gap: calc(var(--x-padding) / 2);
        }
        .title {
          padding: 0;
          margin: 0;
          font: var(--font-heading-xs);
          color: var(--color-marca-oscuro);
        }
        .pricing {
          padding: 0;
          margin: 0;
          font: var(--font-heading-s);
          color: rgb(var(--color-marca-rebajas));
        }
        img {
          display: block;
          max-width: 100%;
          aspect-ratio: 16 / 14;
          object-fit: cover;
          object-position: center;
        }
        .actions {
          display: flex;
          width: 100%;
          justify-content: space-between;
        }
        .remove-button {
          background: transparent;
          border: 0;
          color: rgba(var(--color-marca-oscuro));
          padding-left: 0;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .unit_price {
          color: rgb(var(--color-marca-oscuro3));
          font-size: var(--fs-xs);
        }
        .actions > h-loading {
          display: none;
        }
        .actions.loading {
          pointer-events: none;
        }
        .actions.loading > * {
          visibility: hidden;
        }
        .actions.loading > h-loading {
          display: block !important;
          visibility: visible;
        }
      </style>
      <div class="container">
        <div class="image-wrapper">
          <img src="${image}" alt="${title}">
        </div>
        <div class="content">
          <h2 class="title">${title}</h1>
          <p class="pricing">${price}<span class="unit_price">[final_price]</span></p>
          <div class="actions">
            <button class="remove-button" on-click="quit">
              <svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.5931 8.41458H18.837V7.52025C18.8346 6.99916 18.6266 6.50008 18.2581 6.13161C17.8896 5.76313 17.3905 5.55509 16.8694 5.55273H12.5767C12.0556 5.55509 11.5565 5.76313 11.188 6.13161C10.8196 6.50008 10.6115 6.99916 10.6092 7.52025V8.41458H6.853C6.71069 8.41458 6.5742 8.47111 6.47357 8.57174C6.37294 8.67237 6.31641 8.80886 6.31641 8.95117C6.31641 9.09349 6.37294 9.22997 6.47357 9.3306C6.5742 9.43123 6.71069 9.48777 6.853 9.48777H7.74733V22.5449C7.74733 22.877 7.87924 23.1955 8.11405 23.4303C8.34885 23.6651 8.66732 23.797 8.99938 23.797H20.4468C20.7788 23.797 21.0973 23.6651 21.3321 23.4303C21.5669 23.1955 21.6988 22.877 21.6988 22.5449V9.48777H22.5931C22.7354 9.48777 22.8719 9.43123 22.9726 9.3306C23.0732 9.22997 23.1297 9.09349 23.1297 8.95117C23.1297 8.80886 23.0732 8.67237 22.9726 8.57174C22.8719 8.47111 22.7354 8.41458 22.5931 8.41458ZM11.6824 7.52025C11.6824 7.28306 11.7766 7.05559 11.9443 6.88787C12.112 6.72015 12.3395 6.62593 12.5767 6.62593H16.8694C17.1066 6.62593 17.3341 6.72015 17.5018 6.88787C17.6696 7.05559 17.7638 7.28306 17.7638 7.52025V8.41458H11.6824V7.52025ZM20.6256 22.5449C20.6256 22.5924 20.6068 22.6379 20.5732 22.6714C20.5397 22.7049 20.4942 22.7238 20.4468 22.7238H8.99938C8.95195 22.7238 8.90645 22.7049 8.87291 22.6714C8.83936 22.6379 8.82052 22.5924 8.82052 22.5449V9.48777H20.6256V22.5449ZM13.1133 13.2439V18.9676C13.1133 19.1099 13.0567 19.2464 12.9561 19.347C12.8555 19.4477 12.719 19.5042 12.5767 19.5042C12.4344 19.5042 12.2979 19.4477 12.1973 19.347C12.0966 19.2464 12.0401 19.1099 12.0401 18.9676V13.2439C12.0401 13.1016 12.0966 12.9651 12.1973 12.8645C12.2979 12.7639 12.4344 12.7073 12.5767 12.7073C12.719 12.7073 12.8555 12.7639 12.9561 12.8645C13.0567 12.9651 13.1133 13.1016 13.1133 13.2439ZM17.406 13.2439V18.9676C17.406 19.1099 17.3495 19.2464 17.2489 19.347C17.1482 19.4477 17.0118 19.5042 16.8694 19.5042C16.7271 19.5042 16.5906 19.4477 16.49 19.347C16.3894 19.2464 16.3329 19.1099 16.3329 18.9676V13.2439C16.3329 13.1016 16.3894 12.9651 16.49 12.8645C16.5906 12.7639 16.7271 12.7073 16.8694 12.7073C17.0118 12.7073 17.1482 12.7639 17.2489 12.8645C17.3495 12.9651 17.406 13.1016 17.406 13.2439Z" fill="black"/>
              </svg>
            </button>
            <h-quantity-selector quantity="[quantity]" variant="${variant_id}"></h-quantity-selector>
            <h-loading></h-loading>
          </div>
        </div>
      </div>
    `
  }
  mount() {
    super.mount()
    this.actions = this.querySelector(".actions")
  }
  quit() {
    this.actions.classList.add('loading')
    this.cart.updateItem({
      id: this.variant_id,
      quantity: 0
    })
  }
}
customElements.define('h-cart-item', HCartItem)

class HQuantitySelector extends HReactiveElement {
  debounceTime
  debounceLoading
  constructor() {
    super()
    this.cart = document.querySelector("#cartData")
  }
  onUpdateFinished() {
    if (this.debounceLoading) clearTimeout(this.debounceLoading)
    this.debounceLoading = setTimeout(() => {
      this.parentElement.classList.remove('loading')
    }, 500)
  }
  updateItem() {
    if (this.debounceTime) clearTimeout(this.debounceTime)
    this.debounceTime = setTimeout(() => {
      this.prevQuantity = null
      this.parentElement.classList.add('loading')
      this.cart.updateItem({
        id: this.variant,
        quantity: this.quantity
      })
    }, 500)
  }
  template() {
    return `
    <style>
      .container {
        display: grid;
        grid-template-columns: repeat(3,auto);
        width: fit-content;
        background: rgb(var(--color-marca-beis-dark));
        border-radius: var(--radius--button);
      }
      input, button {
        padding: .8em .5em;
        text-align: center;
        appearance: none;
        font-weight: bold;
        background: transparent;
        border: transparent;
        font-size: var(--font-heading-xs);
        color: var(--color-marca-oscuro);
      }
      input[type="number"] {
        appearance: textfield;
        -moz-appearance: textfield;
        -webkit-appearance: textfield;
      }
      button {
        padding: .5em 1em;
      }
      input {
        width: 4ch;
      }
      input:focus {
        outline: none;
      }
    </style>
    <div class="container">
      <button on-click="decrement">-</button>
      <input type="number" on-change="change" value="[quantity]">
      <button on-click="increment">+</button>
    </div>
    `
  }
  increment() {
    if (!this.prevQuantity) this.prevQuantity = this.quantity
    this.quantity = Number(this.quantity) + 1
    this.updateItem()
  }
  decrement() {
    this.quantity = Number(this.quantity) - 1
    this.updateItem()
  }
  change(e) {
    this.quantity = Number(e.target.value)
    this.updateItem()
  }
}
customElements.define('h-quantity-selector', HQuantitySelector)

class HCartDrawerFooter extends HReactiveElement {
  total = '$0'
  constructor() {
    super()
    this.makeState('total', this.total)
  }
  mount() {
    super.mount()
  }
  onGlobalUpdate({ state }) {
    this.total = cartData.total
  }
}
customElements.define('h-cart-drawer-footer', HCartDrawerFooter)